module.exports = __webpack_public_path__ + "static/media/Image_Microsite_Consoles_SE3.a8a5b728.png";